<template>
	<div
		class="product-info"
		v-bind:class="{ border: showRightBorder }"
		@click="productClick"
	>
		<img
			class="product-icon"
			v-bind:src="item.groupbuy_url"
		/>
		<span class="product-title">{{ item.goods_name }}</span>

    <div class="progress-tips">
      <div class="seckill_items_reserve">
        <span class="em" :style="{width: item.percent+'%'}"></span>
      </div>
      <div class="percent">{{item.percent}}%</div>
    </div>

    <div class="qianggou_time" id="qianggou_time">
      <span v-if="day"><em>{{day}}</em> days </span>
      <span><em>{{hours}}</em>:</span>
      <span><em>{{minute}}</em>:</span>
      <span><em>{{second}}</em></span>
    </div>

		<div class="product-bottom">
			<span class="product-price">${{ item.groupbuy_price }}</span>
			<span class="product-buy">sales {{ item.goods_salenum }}</span>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'IndexSeckillBody',
  data () {
    return {
      flag: false,
      day: 0,
      hours: 0,
      minute: 0,
      second: 0,
      time: false,
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 === 0
    }
  },
  props: ['item', 'index'],
  computed: {

  },
  mounted () {
    this.time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(this.time)
      } else {
        this.timeDown()
      }
    }, 1000)
  },
  methods: {
    productClick: function () {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
    },
    /*
    * timeDown: 倒计时
    */
    timeDown () {
      let end_time = false
      if (this.item.groupbuy_endtime) {
        end_time = this.item.groupbuy_endtime
      }
      if (end_time) {
        const endTime = new Date(end_time * 1000)
        const nowTime = new Date()
        let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
        this.day = parseInt(leftTime / (24 * 60 * 60))
        this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
        this.minute = this.formate(parseInt((leftTime / 60) % 60))
        this.second = this.formate(parseInt(leftTime % 60))
        if (leftTime <= 0) {
          this.flag = true
          $('.qianggou_time').html('The event is over')
        }
      }
    },
    /*
     * 格式化时间
     */
    formate (time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qianggou_time {
  width: auto;
  font-size: .6rem;
  line-height: 1rem;
  text-align: left;
}
.qianggou_time em {
  display: inline-block;
  width: 0.9rem;
  height: 1rem;
  line-height: 1rem;
  background-color: #e93b3d;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.progress-tips {
  margin-top: -.2rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.2rem;
}
.seckill_items_reserve {
  width: 5rem;
  height: .2rem;
  background: #f1c0bd;
  border-radius: 2.5rem;
  position: relative;
}
.seckill_items_reserve .em {
  background: #e93b3d;
  border-radius: .6rem;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
}
.progress-tips .percent {
  color: #e93b3d;
  font-size: .45rem;
  z-index: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: .2rem;
}
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0.5rem;
	justify-content: flex-end;
	border-bottom: 1px solid #f5f5f5;
	width: 50%;
  box-sizing: border-box;
	.product-icon {
		align-self: center;
		width: 100%;
    box-sizing: border-box;
	}
	.product-title {
		color: #333;
		font-size: .7rem;
		line-height: 1rem;
		margin-top: 0.4rem;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.product-bottom {
		display: flex;
		justify-content: space-between;
		margin-top:.2rem;
		line-height: 1rem;
		.product-price {
			color: $primaryColor;
			font-size: .7rem;
		}
		.product-buy {
			color: #999999;
			font-size:.65rem;
		}
	}
}
</style>
